import React from 'react';


export class Contactos extends React.Component {

	componentDidMount () {
        const script = document.createElement("script");

        script.async = true;
        
		script.innerHTML = "$('.modal-backdrop').remove();$('body').removeClass('modal-open')"; 

        document.body.appendChild(script);


    }

	
	render(){
		return (
			<div id="contactos">
		
				<section class="container-fluid contact-container">
						<article class="row justify-content-md-left">
							<div class="col-8 col-form-box">
								<div class="bg-box-form">
									
										<form action="/imga/contacts.php" method="post" class="col-md-12 bg-form wrap">
											<h3>Consultar</h3>
											<div class="row">
												<div class="col-md-12">
													<div class="form-group">
														<label for="">Nombre y apellido</label>
														<input type="text" class="form-control" id="name" name="nombre"/>
													</div>
												</div>

												
												<div class="col-md-12">
													<div class="form-group">
														<label for="">Email</label>
														<input type="email" class="form-control" id="mail" name="email"/>
													</div>
												</div>
												<div class="col-md-12">
													<div class="form-group">
														<label for="" >Teléfono</label>
														<input type="phone" class="form-control" id="telefono" name="tel"/>
													</div>
												</div>
												<div class="col-md-12">
													<div class="form-group">
														<label for="">Mensaje</label>
														<textarea class="form-control" id="comment" name="mensaje" rows="3"></textarea>
													</div>
												</div>
												<div class="col-md-12 box-btn text-right">
													<div class="row justify-content-end">
														<div class="col-md-4">
															<button type="submit" class="btn pedir-presupuesto">Enviar</button>
														</div>
													</div>
												</div>
											</div>
										</form>
									
								</div>
								
							</div>
						</article>
						
					</section>
			</div>
		);
	}
} 


// WEBPACK FOOTER //
// ./src/components/Contactos.js